"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var FormControl_1 = __importDefault(require("@mui/material/FormControl"));
var react_1 = require("react");
var react_2 = require("@emotion/react");
var InputLabel_1 = __importDefault(require("../../../Components/Atoms/InputLabel"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeFormControlPhoneNumberStyling_1 = __importDefault(require("./__helpers__/styling/makeFormControlPhoneNumberStyling"));
var makeFormControlStyles_1 = __importDefault(require("../../../Components/Atoms/FormControl/makeFormControlStyles"));
var CountryDropdown_1 = __importDefault(require("./__helpers__/components/ui/CountryDropdown"));
var CountryModal_1 = __importDefault(require("./__helpers__/components/ui/CountryModal"));
var PhoneInput_1 = __importDefault(require("./__helpers__/components/forms/PhoneInput"));
var CountrySelector_1 = __importDefault(require("./__helpers__/components/ui/CountrySelector"));
var ErrorDisplay_1 = __importDefault(require("./__helpers__/components/display/ErrorDisplay"));
var usePhoneNumber_1 = require("./__helpers__/hooks/usePhoneNumber");
var useCountrySelector_1 = require("./__helpers__/hooks/useCountrySelector");
var PhoneNumberTextField = function (_a) {
    var _b, _c;
    var 
    // Core props
    id = _a.id, _d = _a.value, value = _d === void 0 ? '' : _d, label = _a.label, errorMessage = _a.errorMessage, disabled = _a.disabled, placeholder = _a.placeholder, 
    // Country settings
    initialCountry = _a.initialCountry, enableCountryChange = _a.enableCountryChange, enableCountrySearch = _a.enableCountrySearch, useModalForCountrySelection = _a.useModalForCountrySelection, 
    // UI state
    isAnswered = _a.isAnswered, isSafari = _a.isSafari, isAutoFilledActive = _a.isAutoFilledActive, experimentName = _a.experimentName, 
    // Input filtering settings
    strictMode = _a.strictMode, 
    // Country selection customization
    countrySearchPlaceholder = _a.countrySearchPlaceholder, countryModalHeading = _a.countryModalHeading, preferredCountries = _a.preferredCountries, 
    // Callbacks
    onPhoneNumberChange = _a.onPhoneNumberChange, onCountryChange = _a.onCountryChange, onValidationChange = _a.onValidationChange, onFormattedValueChange = _a.onFormattedValueChange, onChange = _a.onChange, // Legacy support
    // Event handlers
    onBlur = _a.onBlur, onClick = _a.onClick, type = _a.type, props = __rest(_a, ["id", "value", "label", "errorMessage", "disabled", "placeholder", "initialCountry", "enableCountryChange", "enableCountrySearch", "useModalForCountrySelection", "isAnswered", "isSafari", "isAutoFilledActive", "experimentName", "strictMode", "countrySearchPlaceholder", "countryModalHeading", "preferredCountries", "onPhoneNumberChange", "onCountryChange", "onValidationChange", "onFormattedValueChange", "onChange", "onBlur", "onClick", "type"]);
    var theme = (0, react_2.useTheme)();
    var countrySelectorRef = (0, react_1.useRef)(null);
    var inputRef = (0, react_1.useRef)(null);
    // Custom hooks for clean separation of concerns
    var phoneNumber = (0, usePhoneNumber_1.usePhoneNumber)({
        initialCountry: initialCountry,
        initialValue: value,
        enableCountryChange: enableCountryChange,
        preferredCountries: preferredCountries,
    });
    var countrySelector = (0, useCountrySelector_1.useCountrySelector)({
        enableCountryChange: enableCountryChange,
        disabled: disabled,
    });
    // Use refs to track previous values
    var prevPhoneNumberRef = (0, react_1.useRef)('');
    var prevE164Ref = (0, react_1.useRef)('');
    var prevIsValidRef = (0, react_1.useRef)(false);
    var prevCountryCodeRef = (0, react_1.useRef)('');
    // Handle auto-detected country changes
    (0, react_1.useEffect)(function () {
        if (phoneNumber.autoDetectedCountryChange) {
            var _a = phoneNumber.autoDetectedCountryChange, newCountry = _a.newCountry, previousCountry = _a.previousCountry;
            // Trigger the country change callback for auto-detection
            onCountryChange === null || onCountryChange === void 0 ? void 0 : onCountryChange({
                id: id,
                selectedCountry: newCountry,
                previousCountry: previousCountry,
            });
            // Clear the auto-detected country change flag
            phoneNumber.clearAutoDetectedCountryChange();
        }
    }, [
        phoneNumber.autoDetectedCountryChange,
        phoneNumber.clearAutoDetectedCountryChange,
        onCountryChange,
        id,
    ]);
    // Handle phone number change events with proper change detection
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var currentPhoneNumber = phoneNumber.phoneNumber;
        var currentE164 = phoneNumber.formattedE164;
        var currentIsValid = phoneNumber.isValid;
        var currentCountryCode = (_b = (_a = phoneNumber.selectedCountry) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : '';
        // Only trigger callbacks if values have actually changed
        var phoneNumberChanged = currentPhoneNumber !== prevPhoneNumberRef.current;
        var e164Changed = currentE164 !== prevE164Ref.current;
        var validityChanged = currentIsValid !== prevIsValidRef.current;
        var countryChanged = currentCountryCode !== prevCountryCodeRef.current;
        if (phoneNumberChanged ||
            e164Changed ||
            validityChanged ||
            countryChanged) {
            // Update refs first to prevent re-triggering
            prevPhoneNumberRef.current = currentPhoneNumber;
            prevE164Ref.current = currentE164;
            prevIsValidRef.current = currentIsValid;
            prevCountryCodeRef.current = currentCountryCode;
            // Call specific callbacks with properly separated concerns
            if (phoneNumberChanged || e164Changed) {
                onPhoneNumberChange === null || onPhoneNumberChange === void 0 ? void 0 : onPhoneNumberChange({
                    id: id,
                    phoneNumber: currentPhoneNumber, // What user sees (national format)
                    e164Number: currentE164, // E164 format for backend
                });
            }
            if (phoneNumber.validationResult &&
                (phoneNumberChanged || validityChanged)) {
                onValidationChange === null || onValidationChange === void 0 ? void 0 : onValidationChange({
                    id: id,
                    isValid: currentIsValid,
                    validationResult: phoneNumber.validationResult,
                    phoneNumber: currentPhoneNumber,
                });
            }
            if (phoneNumberChanged || e164Changed) {
                onFormattedValueChange === null || onFormattedValueChange === void 0 ? void 0 : onFormattedValueChange({
                    id: id,
                    formattedValue: currentPhoneNumber, // What user sees (national format)
                    e164Value: currentE164, // What gets submitted (international format)
                });
            }
            // Call legacy callback for backward compatibility
            if (phoneNumber.validationResult &&
                (phoneNumberChanged || e164Changed || validityChanged)) {
                onChange === null || onChange === void 0 ? void 0 : onChange({
                    id: id,
                    value: currentE164, // This is E164 format for backend
                    isValid: currentIsValid,
                    selectedCountry: phoneNumber.selectedCountry,
                    validationResult: phoneNumber.validationResult,
                });
            }
        }
    }, [
        id,
        phoneNumber.phoneNumber,
        phoneNumber.formattedE164,
        phoneNumber.isValid,
        (_b = phoneNumber.selectedCountry) === null || _b === void 0 ? void 0 : _b.code,
        phoneNumber.validationResult,
        onPhoneNumberChange,
        onValidationChange,
        onFormattedValueChange,
        onChange,
    ]);
    // Memoized callbacks to prevent unnecessary re-renders
    var handlePhoneChange = (0, react_1.useCallback)(function (params) {
        phoneNumber.setPhoneNumber(params.value);
    }, [phoneNumber.setPhoneNumber]);
    // Handle country changes
    var handleCountryChange = (0, react_1.useCallback)(function (country) {
        var previousCountry = phoneNumber.selectedCountry;
        phoneNumber.setSelectedCountry(country);
        onCountryChange === null || onCountryChange === void 0 ? void 0 : onCountryChange({
            id: id,
            selectedCountry: country,
            previousCountry: previousCountry,
        });
    }, [
        phoneNumber.setSelectedCountry,
        phoneNumber.selectedCountry,
        id,
        onCountryChange,
    ]);
    var formControlStyles = [
        (0, makeFormControlPhoneNumberStyling_1.default)({
            isAnswered: isAnswered !== null && isAnswered !== void 0 ? isAnswered : false,
            isAutoFilledActive: isAutoFilledActive !== null && isAutoFilledActive !== void 0 ? isAutoFilledActive : false,
            isSafari: isSafari !== null && isSafari !== void 0 ? isSafari : false,
            hasError: !!errorMessage,
            theme: theme,
        }),
        (0, makeFormControlStyles_1.default)({
            isAutoFilledActive: isAutoFilledActive !== null && isAutoFilledActive !== void 0 ? isAutoFilledActive : false,
            isSafari: isSafari !== null && isSafari !== void 0 ? isSafari : false,
            theme: theme,
        }),
    ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(FormControl_1.default, { variant: "standard", error: !!errorMessage, fullWidth: true, css: formControlStyles, sx: { position: 'relative' }, children: [label && ((0, jsx_runtime_1.jsx)(InputLabel_1.default, { id: "".concat(id, "-label"), isAnswered: isAnswered !== null && isAnswered !== void 0 ? isAnswered : false, htmlFor: id, shrink: true, experimentName: experimentName, children: label })), (0, jsx_runtime_1.jsxs)("div", { className: "phone-input-container", role: "group", "aria-labelledby": label ? "".concat(id, "-label") : undefined, "aria-describedby": errorMessage ? "".concat(id, "-error") : undefined, children: [(0, jsx_runtime_1.jsx)(CountrySelector_1.default, { ref: countrySelectorRef, selectedCountry: phoneNumber.selectedCountry, enableCountryChange: enableCountryChange, isCountryMenuOpen: countrySelector.isCountryMenuOpen, disabled: disabled, onClick: countrySelector.handleCountrySelectClick, onKeyDown: countrySelector.handleKeyDown }), (0, jsx_runtime_1.jsx)(PhoneInput_1.default, __assign({ ref: inputRef, id: id, value: phoneNumber.phoneNumber, placeholder: (0, react_1.useMemo)(function () { var _a; return placeholder || ((_a = phoneNumber.selectedCountry) === null || _a === void 0 ? void 0 : _a.example) || ''; }, [placeholder, (_c = phoneNumber.selectedCountry) === null || _c === void 0 ? void 0 : _c.example]), disabled: disabled, error: !!errorMessage, isAnswered: isAnswered, isSafari: isSafari, isAutoFilledActive: isAutoFilledActive, experimentName: experimentName, type: type, strictMode: strictMode, onChange: handlePhoneChange, onBlur: onBlur, onClick: onClick }, props))] }), (0, jsx_runtime_1.jsx)(ErrorDisplay_1.default, { id: "".concat(id, "-error"), errorMessage: errorMessage, role: "alert", "aria-live": "polite" })] }), enableCountryChange && useModalForCountrySelection ? ((0, jsx_runtime_1.jsx)(CountryModal_1.default, { selectedCountry: phoneNumber.selectedCountry, onCountryChange: handleCountryChange, enableCountrySearch: enableCountrySearch, open: countrySelector.isCountryMenuOpen, onClose: countrySelector.closeCountryMenu, searchPlaceholder: countrySearchPlaceholder, modalHeading: countryModalHeading, countries: phoneNumber.countries })) : ((0, jsx_runtime_1.jsx)(CountryDropdown_1.default, { selectedCountry: phoneNumber.selectedCountry, onCountryChange: handleCountryChange, enableCountrySearch: enableCountrySearch, anchorEl: countrySelectorRef.current, open: countrySelector.isCountryMenuOpen, onClose: countrySelector.closeCountryMenu, searchPlaceholder: countrySearchPlaceholder, countries: phoneNumber.countries }))] }));
};
PhoneNumberTextField.defaultProps = defaultProps_1.default;
exports.default = PhoneNumberTextField;
//# sourceMappingURL=PhoneNumberTextField.js.map